export const getGroupStyles = ({ theme, language, screenSize, spacing, fonts }) => ({
    container: {
        direction: language === "ar" ? "rtl" : "ltr",
    },
    header: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        borderRadius: screenSize === "xs" ? "1rem" : "1.5rem",
        padding: spacing.padding,
        marginBottom: spacing.margin,
    },
    headerContent: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: screenSize === "xs" ? "flex-start" : "center",
        flexDirection: screenSize === "xs" ? "column" : "row",
        gap: spacing.gap,
    },
    title: {
        color: theme === "dark" ? "white" : "#1a1a1a",
        fontSize: "28px",
        fontWeight: "700",
        margin: 0,
        marginBottom: "0.5rem",
    },
    subtitle: {
        color: theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
        fontSize: fonts.subtitle,
        margin: 0,
    },
    buttonGroup: {
        display: "flex",
        gap: "0.75rem",
        flexWrap: "wrap",
    },
    createBtn: {
        background: "#2e7cba",
        color: "white",
        border: "none",
        padding: screenSize === "xs" ? "0.75rem 1rem" : "0.75rem 1.5rem",
        borderRadius: "0.75rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        transition: "all 0.3s ease",
    },
    searchContainer: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        padding: spacing.padding,
        borderRadius: "1.2rem",
        marginBottom: spacing.margin,
    },
    searchInput: {
        background: theme === "dark" ? "rgba(255, 255, 255, 0.05)" : "white",
        border: theme === "dark"
            ? "1px solid rgba(255, 255, 255, 0.1)"
            : "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "0.75rem",
        padding: screenSize === "xs" ? "0.625rem 0.75rem" : "0.75rem 1rem",
        color: theme === "dark" ? "rgba(255,255,255,0.95)" : "#0f172a",
        fontWeight: 700,
        fontSize: fonts.body,
        outline: "none",
        width: "101%",
    },
    groupsGrid: {
        display: "grid",
        gridTemplateColumns: screenSize === "xs"
            ? "1fr"
            : screenSize === "sm"
                ? "repeat(2, 1fr)"
                : "repeat(3, 1fr)",
        gap: spacing.gap,
    },
    groupCard: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: "1.25rem",
        borderRadius: "1rem",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        transition: "all 0.3s ease",
    },
    tabContainer: {
        display: "flex",
        gap: screenSize === "xs" ? "0.5rem" : "1rem",
        marginBottom: spacing.margin,
        padding: screenSize === "xs" ? "0.75rem" : "1rem",
        background: theme === "dark"
            ? "rgba(255,255,255,0.03)"
            : "rgba(255,255,255,0.6)",
        borderRadius: "1rem",
        backdropFilter: "blur(10px)",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.08)"
            : "1px solid rgba(0,0,0,0.05)",
        boxShadow: theme === "dark"
            ? "0 4px 12px rgba(0,0,0,0.15)"
            : "0 2px 8px rgba(0,0,0,0.06)",
        transition: "all 0.3s ease",
    },

    tab: {
        background: "transparent",
        border: "none",
        padding: screenSize === "xs" ? "0.625rem 1rem" : "0.875rem 1.5rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        color: theme === "dark"
            ? "rgba(255,255,255,0.5)"
            : "rgba(26,26,26,0.6)",
        borderRadius: "0.75rem",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        position: "relative",
        overflow: "hidden",
        letterSpacing: "0.01em",
        textTransform: "capitalize",
        whiteSpace: "nowrap",
    },

    activeTab: {
        color: "white",
        background: "#2e7cba",
        boxShadow: "0 4px 12px rgba(46,124,186,0.25)",
        border: "1px solid rgba(46,124,186,0.25)",
    },
    modal: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        padding: screenSize === "xs" ? "1rem" : "2rem",
    },
    modalContent: {
        background: theme === "dark"
            ? "rgba(20, 25, 40, 0.95)"
            : "rgba(255, 255, 255, 0.95)",
        borderRadius: screenSize === "xs" ? "1rem" : "1.5rem",
        padding: screenSize === "xs" ? "1.5rem" : "2.5rem",
        width: screenSize === "xs" ? "100%" : "90%",
        maxWidth: "500px",
        border: theme === "dark"
            ? "1px solid rgba(255, 255, 255, 0.12)"
            : "1px solid rgba(46, 124, 186, 0.18)",
        boxShadow: theme === "dark"
            ? "0 25px 50px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.05)"
            : "0 25px 50px rgba(46, 124, 186, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
    },
    formGroup: {
        marginBottom: spacing.margin,
    },
    formLabel: {
        display: "block",
        color: theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
        fontSize: fonts.body,
        fontWeight: "500",
        marginBottom: "0.5rem",
    },
    formInput: {
        background: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.9)",
        border: theme === "dark"
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(46, 124, 186, 0.2)",
        borderRadius: "0.75rem",
        padding: "0.75rem 1rem",
        color: theme === "dark" ? "white" : "#1a1a1a",
        fontSize: fonts.body,
        outline: "none",
        width: "100%",
        transition: "all 0.3s ease",
    },
    formSelect: {
        appearance: "none",
        background: theme === "dark"
            ? "rgba(30, 41, 59, 0.8)"
            : "rgba(255, 255, 255, 0.95)",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(46, 124, 186, 0.2)",
        borderRadius: "0.75rem",
        padding: screenSize === "xs" ? "0.75rem 2rem 0.75rem 1rem" : "0.75rem 2rem 0.75rem 1rem",
        color: theme === "dark"
            ? "rgba(248, 250, 252, 0.95)"
            : "rgba(30, 41, 59, 0.9)",
        fontSize: fonts.body,
        outline: "none",
        width: "100%",
        cursor: "pointer",
        transition: "all 0.3s ease",
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='${theme === "dark" ? "%232e7cba" : "%232e7cba"
            }' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: language === "ar" ? "left 0.75rem center" : "right 0.75rem center",
    },
    submitBtn: {
        background: "#2e7cba",
        color: "white",
        border: "none",
        padding: "0.875rem 2rem",
        borderRadius: "0.75rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        transition: "all 0.3s ease",
        width: "100%",
        boxShadow: "none",
    },
    card1: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        WebkitBackdropFilter: theme === "dark" ? "blur(25px) saturate(180%)" : "blur(10px)",
        border: theme === "dark" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
        borderRadius: screenSize.isMobile ? "12px" : screenSize.isTablet ? "20px" : "28px",
        padding: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "28px",
        marginBottom: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "24px",
        transition: "all 0.3s ease",
        cursor: "pointer",
        //direction: language === "ar" ? "rtl" : "ltr",
    },

    cancelBtn: {
        background: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(46, 124, 186, 0.1)",
        color: theme === "dark" ? "white" : "#2e7cba",
        border: theme === "dark"
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(46, 124, 186, 0.3)",
        padding: "0.875rem 2rem",
        borderRadius: "0.75rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        transition: "all 0.3s ease",
        width: "100%",
    },
    emptyState: {
        textAlign: "center",
        padding: screenSize === "xs" ? "3rem 1rem" : "4rem 2rem",
        color: theme === "dark" ? "rgba(255, 255, 255, 0.5)" : "rgba(26, 26, 26, 0.5)",
    },
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1.5rem",
        paddingBottom: "1rem",
        borderBottom: theme === "dark"
            ? "2px solid rgba(255, 255, 255, 0.08)"
            : "2px solid rgba(46, 124, 186, 0.15)",
    },
    modalTitle: {
        margin: 0,
        fontSize: fonts.subtitle,
        fontWeight: "700",
        color: theme === "dark" ? "white" : "#1a1a1a",
    },
    closeButton: {
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "0.5rem",
        color: theme === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(46, 124, 186, 0.7)",
        transition: "all 0.3s ease",
        borderRadius: "0.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalActions: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "1rem",
        marginTop: "1.5rem",
    },
    primaryButton: {
        background: "#2e7cba",
        color: "white",
        border: "none",
        padding: "0.875rem 1.5rem",
        borderRadius: "0.75rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
        // boxShadow: "none",
    },
    secondaryButton: {
        background: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(46, 124, 186, 0.1)",
        color: theme === "dark" ? "white" : "#2e7cba",
        border: theme === "dark"
            ? "1.5px solid rgba(255, 255, 255, 0.2)"
            : "1.5px solid rgba(46, 124, 186, 0.3)",
        padding: "0.875rem 1.5rem",
        borderRadius: "0.75rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});